'use client';

import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { useContext } from 'react';

import {
  TITLE_HEADING_H2,
  TITLE_HEADING_H3,
} from '@/components/section-container/base';
import {
  TITLE_HEADING_DIV,
} from '@/components/section-container/base/constants';
import { SectionContainer } from '@/components/section-container/page';
import { TextLink } from '@/components/text-link';
import { InfoContext } from '@/context/info';
import { joinSgcmSite } from '@/utils/url/join/public';
import { getInternalLink } from '@/utils/url/utm';

import { Alert } from '../../../_components/page-content/alert';
import {
  PAST_CAR_TERMINATED_PROMPT,
} from '../../../_components/page-content/alert/constants';
import {
  CAR_STATUS_ON_HOLD,
  SECTION_TITLE_RECOMMENDED_FOR_YOU,
} from '../../../_components/page-content/constants';
import {
  EditorialReview,
} from '../../../_components/page-content/editorial-review';
import {
  RecommendedForYouForInfo,
} from '../../../_components/page-content/recommended-for-you-for-info';
import { Articles } from './articles/component';
import {
  SECTION_TITLE_DISCUSSIONS,
  SECTION_TITLE_FACELIFT_REVIEWS,
  SECTION_TITLE_RELATED_ARTICLES,
} from './constants';
import { Discussions } from './discussions';
import { MyCarForum } from './my-car-forum/component';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PageContent: Component = ({
  carDetailDiscussion,
  carRelatedArticles,
  editorialReviewList,
}) => {
  const hasDiscussionData = carDetailDiscussion.length > 0;
  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();
  const editorialReview = editorialReviewList[0];
  const { carDetail } = useContext(InfoContext);

  function getFirstModelWord(str: string) {
    const spaceIndex = str.indexOf(' ');

    if (spaceIndex !== -1) {
      return str.slice(0, spaceIndex);
    }
    return str;
  }

  const viewAllArticlesLink = `${joinSgcmSite(`articles/listing?q=${carDetail.make}%20${getFirstModelWord(carDetail.model)}`)}`;

  const viewAllDiscussionLink = `https://www.mycarforum.com/search?search_and_or=or&search_in=titles&q=${getFirstModelWord(carDetail.model)}`;

  const isPastCar = !(carDetail.additionalProperties.isAvailable
    || carDetail.additionalProperties.isUpcoming);
  const { status } = carDetail.additionalProperties;
  const isOnHold = status === CAR_STATUS_ON_HOLD;

  return (
    <main
      className={styles.containerPageRoot}>
      {
        isPastCar && !isOnHold
        && (
          <SectionContainer
            title=""
            titleHeading={TITLE_HEADING_DIV}>
            <Alert
              date={carDetail.terminationDate}
              text={PAST_CAR_TERMINATED_PROMPT} />
          </SectionContainer>
        )
      }
      {
        editorialReview && (
          <SectionContainer
            className={styles.containerPageContent}
            title={SECTION_TITLE_FACELIFT_REVIEWS}
            titleHeading={TITLE_HEADING_H3}>
            <EditorialReview
              make={carDetail.make}
              review={editorialReview} />
          </SectionContainer>
        )
      }
      <SectionContainer
        title={`${isDesktopMode
          ? `${SECTION_TITLE_RELATED_ARTICLES} To ${carDetail.make} ${carDetail.model}`
          : `${SECTION_TITLE_RELATED_ARTICLES}`} `}
        titleAsideContent={(
          <TextLink
            className={styles.linkViewAll}
            href={getInternalLink(viewAllArticlesLink, 'discussions')}
            target="_self"
            text="View All" />
        )}
        titleHeading={TITLE_HEADING_H3}>
        <Articles
          carRelatedArticles={carRelatedArticles}
          isDesktopMode={isDesktopMode} />
      </SectionContainer>
      {hasDiscussionData && (
        <SectionContainer
          title={SECTION_TITLE_DISCUSSIONS}
          titleAsideContent={(
            <TextLink
              className={styles.linkViewAll}
              href={viewAllDiscussionLink}
              target="_blank"
              text="View All" />
          )}
          titleHeading={TITLE_HEADING_H3}>
          <Discussions discussions={carDetailDiscussion.slice(0, 5)} />
        </SectionContainer>
      )}
      {hasDiscussionData && (
        <SectionContainer title="">
          <MyCarForum />
        </SectionContainer>
      )}
      <SectionContainer
        className={styles.containerPageContent}
        title={SECTION_TITLE_RECOMMENDED_FOR_YOU}
        titleHeading={TITLE_HEADING_H2}>
        <RecommendedForYouForInfo />
      </SectionContainer>
    </main>
  );
};
